import { recipe } from "@vanilla-extract/recipes";
import { theme } from "../../theme/css/theme.css";

export const textAreaStyle = recipe({
  base: {
    background: "transparent",
    border: 0,
    outline: "none",
    resize: "none",
    verticalAlign: "text-bottom",
    maxHeight: "25vh",
    flexGrow: 0,
    color: theme.colors.onBackground,
    "::placeholder": {
      color: theme.colors.placeholder,
    },
  },
  variants: {
    disabled: {
      true: {
        cursor: "not-allowed",
      },
    },
  },
  defaultVariants: {},
});
